export const PROTOCOL = "protocol";

export const protocolSubs = (ev) => (ev?.protocol?.enabled ? ev.protocol.subcategories || [] : []);

export const protocolSelection = (ev, protocolId) => {
  const s = protocolSubs(ev).find((x) => x.id === protocolId);
  return s ? { id: s.id, name: `Protocol – ${s.name}`, fee: s.fee, good_standing_only: false } : null;
};

export const ProtocolPicker = ({ ev, value, onChange, Choice, cedi }) => (
  <div className="mt-4 rounded-md border border-[#E60000]/30 bg-[#FFF8F8] p-4" data-testid="reg-protocol-picker">
    <div className="text-sm font-semibold mb-3">Choose your Protocol category</div>
    <div className="grid sm:grid-cols-3 gap-2">
      {protocolSubs(ev).map((s, i) => (
        <Choice key={s.id} active={value === s.id} onClick={() => onChange(s.id)} testId={`reg-protocol-sub-${i}`}>
          <div className="font-semibold">{s.name}</div><div className="font-mono text-xs mt-0.5">{cedi(s.fee)}</div>
        </Choice>
      ))}
    </div>
  </div>
);
